<script setup>
import ResetPassword from "@/components/teacher/ResetPassword.vue";
</script>

<template>
  <ResetPassword />
</template>
